export const actions = {
  NOTIFICATION_SHOW: 'NOTIFICATION_SHOW',
  NOTIFICATION_HIDE: 'NOTIFICATION_HIDE',
  NOTIFICATION_DISMISS: 'NOTIFICATION_DISMISS',
  NOTIFICATION_DISMISSALL: 'NOTIFICATION_DISMISSALL',
  NOTIFICATION_DELETEALL: 'NOTIFICATION_DELETEALL'
};

export default actions;
